export const notEmpty = (item)=>item !== null && item !== undefined;

//# sourceMappingURL=not-empty.js.map